import { ensureJson, IMessageObserver, INotificationProvider } from 'slipstream-components';
import AppUtil from '../../util/AppUtil';

const HAPI_DATA_CHANGE_BASE_URL = '/streams/csp';

export default class DefaultNotificationProvider implements INotificationProvider {
  private existingTopics: string[] = [];
  private observers: IMessageObserver[] = [];
  private currentConnection: EventSource = null;
  private hasSD = false;
  constructor() {
    this.messageCallback = this.messageCallback.bind(this);
  }
  public registerObserver(observer: IMessageObserver) {
    this.observers.push(observer);
  }
  public unRegisterObserver(observer: IMessageObserver) {
    const index = this.observers.indexOf(observer);
    if (index !== -1) {
      this.observers.splice(index, 1);
    }
  }
  public subscribe(topics: string[]) {
    if (topics == null || topics.length === 0) {
      return;
    }

    const newTopics = topics.filter(topic => this.existingTopics.indexOf(topic) === -1);
    if (newTopics.length > 0) {
      this.existingTopics = this.existingTopics.concat(newTopics);
      // SD API is not subscribing to all.
      if (this.hasSD === false) {
        newTopics.forEach(topic => {
          // SD specific subscription.
          if (topic.indexOf(':') === -1) {
            this.hasSD = true;
          }
        });
        this.updateConnection();
      }
    }
  }

  public unSubscribe(topics: string[]) {
    if (topics == null || topics.length === 0) {
      return;
    }
    let foundTopic = false;
    topics.forEach(topic => {
      const index = this.existingTopics.indexOf(topic);
      if (index !== -1) {
        this.existingTopics.splice(index, 1);
        foundTopic = true;
      }
    });

    if (foundTopic) {
      if (this.hasSD) {
        let foundSD = false;
        this.existingTopics.forEach(topic => {
          // SD specific subscription.
          if (topic.indexOf(':') === -1) {
            foundSD = true;
          }
        });

        if (foundSD === false) {
          this.hasSD = false;
          this.updateConnection();
        }
      } else {
        this.updateConnection();
      }
    }
  }

  private messageCallback(message: any) {
    const data = ensureJson(message.data);
    let type = data.type;
    if (type != null) {
      // for compatibility
      if (type.indexOf(':') === -1) {
        type = data.namespace + ':' + type;
      }
    }

    const uri = data.uri;
    this.observers.forEach(obj => obj.onMessage(type, data, uri));
  }

  private updateConnection() {
    if (this.currentConnection) {
      this.currentConnection.close();
    }
    if (this.existingTopics.length > 0) {
      console.log('update subscription: ' + this.existingTopics.join(','));
      const types = this.existingTopics.join(',');
      let subscribeUrl = HAPI_DATA_CHANGE_BASE_URL + '/' + AppUtil.context.getSseToken();

      if (this.hasSD === false) {
        subscribeUrl += '&filter=' + types;
      }
      this.currentConnection = new EventSource(subscribeUrl);
      this.currentConnection.addEventListener('message', this.messageCallback, false);
      this.currentConnection.addEventListener('open', () => {
        console.log('The eventsource connection was established');
      });
      this.currentConnection.addEventListener('error', err => {
        console.error('Error occurred while establishing eventsource connection');
        console.error(err);
      });
    }
  }
}
